module.exports = "<div class=\"discussion-wrap\">\n  <div *ngIf=\"!closed\" style=\"margin-bottom:24px\">\n    <inputbar (submit)=\"submitComment($event)\"></inputbar>\n  </div>\n  <comments [quibbl]=\"qb.currentQuibblIdentifier\"></comments>\n</div>\n\n<footer></footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/category/quibbl-inspector/quibbl-discussion/quibbl-discussion.component.html
// module id = ../../../../../src/app/category/quibbl-inspector/quibbl-discussion/quibbl-discussion.component.html
// module chunks = main